import { useState } from "react";
import { projectsApi } from "../api/projectsApi";
import { PROJECT_STATUSES } from "../constants/projectsViewV2Constants";
import UserSearchSelect from "../../common/components/UserSearchSelect";
import "../../../V2SideDrawer.css";

export default function ProjectDrawer({ item, customers, users, onClose, onSaved, showToast }) {
  const isEdit = !!item;
  const [form, setForm] = useState({
    project_name:    item?.project_name    || "",
    project_code:    item?.project_code    || "",
    customer_id:     item?.customer_id     || "",
    status:          item?.status          || "Active",
    account_manager: item?.account_manager || "",
  });
  const [saving, setSaving] = useState(false);

  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSave = async () => {
    if (!form.project_name.trim()) {
      showToast?.("Project name is required", "warn");
      return;
    }
    if (!form.customer_id) {
      showToast?.("Customer is required", "warn");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        project_name:    form.project_name.trim(),
        project_code:    form.project_code || "",
        account_manager: form.account_manager || null,
      };
      if (isEdit) {
        await projectsApi.updateProject(item.id, { ...payload, status: form.status });
        showToast?.("Project updated ✓");
      } else {
        await projectsApi.createProject({ ...payload, customer_id: form.customer_id });
        showToast?.("Project created ✓");
      }
      onSaved?.();
    } catch (err) {
      showToast?.(err.message || "Failed to save", "warn");
    } finally {
      setSaving(false);
    }
  };

  const activeCustomers = customers.filter(c => c.status === "Active");

  return (
    <>
      <div className="v2drw-scrim" onClick={onClose} />
      <div className="v2drw" role="dialog" aria-modal="true">
        <div className="v2drw-head">
          <div className="v2drw-head-main">
            <p className="v2drw-eyebrow">Project</p>
            <h2 className="v2drw-title">{isEdit ? item.project_name : "New Project"}</h2>
            {isEdit && item.customer_name && (
              <p className="v2drw-meta">{item.customer_name}</p>
            )}
          </div>
          <button className="v2drw-close" onClick={onClose}>✕</button>
        </div>

        <div className="v2drw-body">
          <div className="pjv2-drw-form">
            <div className="pjv2-drw-field">
              <label className="v2drw-form-label">Customer *</label>
              <select
                className="v2drw-control"
                value={form.customer_id}
                onChange={set("customer_id")}
                disabled={isEdit}
              >
                <option value="">— Select customer —</option>
                {(isEdit ? customers : activeCustomers).map(c => (
                  <option key={c.id} value={c.id}>{c.customer_name}</option>
                ))}
              </select>
            </div>

            <div className="pjv2-drw-field">
              <label className="v2drw-form-label">Project Name *</label>
              <input
                className="v2drw-control"
                autoFocus
                value={form.project_name}
                onChange={set("project_name")}
              />
            </div>

            <div className="pjv2-drw-field">
              <label className="v2drw-form-label">Code</label>
              <input
                className="v2drw-control"
                placeholder="Optional short code"
                value={form.project_code}
                onChange={set("project_code")}
              />
            </div>

            {isEdit && (
              <div className="pjv2-drw-field">
                <label className="v2drw-form-label">Status</label>
                <select className="v2drw-control" value={form.status} onChange={set("status")}>
                  {PROJECT_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            )}

            <div className="pjv2-drw-field">
              <label className="v2drw-form-label">Account Manager</label>
              <UserSearchSelect
                users={users}
                value={form.account_manager || ""}
                onChange={(id) => setForm(f => ({ ...f, account_manager: id }))}
                placeholder="Search account manager…"
              />
            </div>
          </div>
        </div>

        <div className="v2drw-foot">
          <span className="v2drw-foot-spacer" />
          <button className="v2drw-btn-cancel" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="v2drw-btn-save" onClick={handleSave} disabled={saving}>
            {saving ? "Saving…" : isEdit ? "Save Changes" : "Create Project"}
          </button>
        </div>
      </div>
    </>
  );
}
